import React, { useState, useEffect, useContext } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import AuthContext from "../../Context/AuthContext";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { useNavigate, useParams } from "react-router-dom";
import { FaMoneyBillAlt, FaPlusCircle, FaCreditCard } from "react-icons/fa";
import ResidenceUser from "../Components/ResidenceUser";
import ResidenceFinanceDetails from "../Components/ResidenceFinanceDetails";
import { ToastContainer, toast } from "react-toastify";

function ResidenceDetails() {
  const [residence, setResidence] = useState({});
  const [users, setUsers] = useState([]);
  const [expectedPayment, setExpectedPayment] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [user, setUser] = useState(null);

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/residences/residence/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setUsers(response.data.users);
      setResidence(response.data.residence);
      setExpectedPayment(response.data.expectedPayment);
      setTotalPaid(response.data.totalPaid);
      setIsLoading(false);
    }
    fetch();
  }, [rid, state.token]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const resetPassword = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/password/reset/${id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      toast("Contraseña reseteada exitosamente");
    } catch (error) {
      console.log(error);
    }
  };

  const renewCodes = async (id) => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/update/codes/user/${id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      toast("Códigos renovados exitosamente");
    } catch (error) {
      console.log(error);
    }
  };

  const revealCodes = async (id) => {
    try {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/${id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setUser(response.data.user);
      handleShow();
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="residence-details">
        <ToastContainer />
        <Col className="residence-address center">
          <h4>{residence.address}</h4>
        </Col>
        <Col className="options-panel center">
          <FaCreditCard onClick={() => navigate(`/card-payments/${rid}`)} />
          <FaMoneyBillAlt onClick={() => navigate(`/manual-payments/${rid}`)} />
          <FaPlusCircle onClick={() => navigate(`/new-user/${rid}`)} />
        </Col>
        <Col className="residence-users mb-4">
          <h5 className="mb-3 mt-3">Residentes</h5>
          {users.map((item) => (
            <ResidenceUser
              key={item._id}
              id={item._id}
              firstName={item.firstName}
              lastName={item.lastName}
              role={state.role}
              resetPassword={resetPassword}
              renewCodes={renewCodes}
              revealCodes={revealCodes}
            />
          ))}
        </Col>
        <hr />
        <ResidenceFinanceDetails
          residence={residence}
          expectedPayment={expectedPayment}
          totalPaid={totalPaid}
        />
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {user ? `${user.firstName} ${user.lastName}` : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <strong>Código de teclado</strong>: {user ? user.pad_code : ""}
            </p>
            <p>
              <strong>Código de tarjeta vehicular</strong>:{" "}
              {user ? user.card_code : ""}
            </p>
            <p>
              <strong>Código de llavero</strong>:{" "}
              {user ? user.keyChain_code : ""}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </Col>
    );
  }
}

export default ResidenceDetails;
